import { createSelector } from 'reselect';
import type { AuthReduxState } from './authSlice';

const getAuthReduxState = (state: { auth: AuthReduxState }) => state.auth;

export const getInitialLogin = createSelector(getAuthReduxState, (state) => state.initialLogin);
